import { useState } from "react";
import { Button, Input } from "reactstrap";
import { toast } from "react-toastify";

import { SelectSearch } from "components/SelectSearch"
import { addCell, cellSuggestion } from "services/api";

export const AddCell = ({
  cell,
  setCell,
  setLoading,
  type = 1 }) => {
  const [showNewCell, setShowNewCell] = useState(false);
  const [newCell, setNewCell] = useState("");

  const addCellHandler = () => {
    if (type === 1) {
      const regex = /^\d{1,2}-[A-Za-z]-\d{1,2}$/;
      if (!regex.test(newCell)) {
        toast.error("Ячейка должна быть вида 9-A-9 или 99-A-99");
        return;
      }
    }
    setLoading(true);
    addCell({ name: newCell })
      .then((res) => {
        toast.success("Ячейка успешно добавлена");
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => {
        setLoading(false);
        setShowNewCell(false);
      });
  };

  return <>
    <SelectSearch
      isClearable
      name="cell"
      placeholder="Выберите ячейку"
      functionSuggestion={cellSuggestion}
      value={cell}
      setValue={setCell}
    />
    <Button
      className="cell__showmodal"
      onClick={() => setShowNewCell(true)}
    >
      +
    </Button>
    {showNewCell && (
      <div className="add-cell">
        {type === 1 &&
          <div>Ячейка должна быть вида 9-A-9 или 99-A-99</div>
        }
        <div>
          <Input
            className="form-control"
            name="newCell"
            placeholder="Добавить ячейку"
            value={newCell || ""}
            onChange={(e) => setNewCell(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <Button onClick={addCellHandler}>Добавить</Button>
          <Button onClick={() => setShowNewCell(false)}>
            Отменить
          </Button>
        </div>
      </div>
    )}
  </>

}